import { cn } from 'lib/helpers/utility';

import PracticeLogo from 'components/shared/PracticeLogo/PracticeLogo';
import { parseHeaderPhoto } from 'components/shared/PracticeLogo/lib/parseHeaderPhoto';

import DocText from '../DocText';
import { DOC_TEXT } from '../lib/docStyles';
import { getPracticeName } from '../lib/practiceLines';

const DocCompactHeader = ({ practice, reference, meta, className }) => {
  const headerPhoto = parseHeaderPhoto(practice?.header_photo);
  const logo = headerPhoto?.jpg || headerPhoto?.png;
  const name = getPracticeName(practice);

  return (
    <div className={className}>
      <div className="flex items-center gap-x-3">
        {logo && (
          <div className="w-7 shrink-0">
            <PracticeLogo
              className="h-7 w-7 rounded-[7px] object-contain"
              image={logo}
              practiceId={practice?.id}
            />
          </div>
        )}
        <DocText size="xs" className={cn(DOC_TEXT.cell, 'min-w-0 flex-1')}>
          <span className="font-700">{name}</span>
          {reference && (
            <>
              {' · '}
              <span className="font-700 text-primary-600">{reference}</span>
            </>
          )}
        </DocText>
        {meta && (
          <DocText size="xs" className={cn(DOC_TEXT.meta, 'w-auto text-right')}>
            {meta}
          </DocText>
        )}
      </div>
      <div className="mt-3 h-px bg-neutral-900" />
    </div>
  );
};

export default DocCompactHeader;
